import { useEffect } from 'react';

const SITE_URL = 'https://verseclinic.com';

const META = {
  en: {
    title: 'VERSE Clinic — Longevity, by Science. Aesthetics, by Precision.',
    description: 'VERSE Clinic is a physician-led longevity and regenerative medicine institute in Malaysia integrating precision aesthetics. Request founding member access.',
    ogLocale: 'en_MY',
  },
  zh: {
    title: 'VERSE Clinic — 以科学定义长寿，以精准雕琢医美。',
    description: 'VERSE Clinic 是马来西亚一家医师主导的长寿与再生医学研究所，融合精准医美。申请创始会员资格。',
    ogLocale: 'zh_CN',
  },
};

export const SEOHead = ({ lang = 'en' }) => {
  useEffect(() => {
    const m = META[lang] || META.en;
    const alt = lang === 'zh' ? 'en' : 'zh';

    document.title = m.title;
    document.documentElement.lang = lang;

    const setMeta = (attr, key, content) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('name', 'description', m.description);
    setMeta('property', 'og:title', m.title);
    setMeta('property', 'og:description', m.description);
    setMeta('property', 'og:locale', m.ogLocale);
    setMeta('property', 'og:url', `${SITE_URL}/${lang}`);

    const setLink = (id, rel, hreflang, href) => {
      let el = document.getElementById(id);
      if (!el) {
        el = document.createElement('link');
        el.id = id;
        document.head.appendChild(el);
      }
      el.setAttribute('rel', rel);
      if (hreflang) el.setAttribute('hreflang', hreflang);
      el.setAttribute('href', href);
    };

    setLink('canonical-link', 'canonical', null, `${SITE_URL}/${lang}`);
    setLink('hreflang-en', 'alternate', 'en', `${SITE_URL}/en`);
    setLink('hreflang-zh', 'alternate', 'zh', `${SITE_URL}/zh`);
    setLink('hreflang-default', 'alternate', 'x-default', `${SITE_URL}/en`);

    return () => {
      ['canonical-link', 'hreflang-en', 'hreflang-zh', 'hreflang-default'].forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, [lang]);

  return null;
};
